import { Box, Typography, TextField, Button, Grid } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useForm, Controller } from 'react-hook-form'
import { useClassification } from '../../../shared/context/classificactionContext'
import { useUtiles } from '../../../shared/context/utilesContext'

export default function CreateClassificationComponent({ type_asset, number }) {
    const theme = useTheme()
    const { createClassification, loadingCreateClassification } = useClassification()
    const { restorePreviousComponent, setAlertSnackbar } = useUtiles()
    const { control, handleSubmit, formState: { errors }, setValue, watch } = useForm({
        defaultValues: {
            value: '',
            type_asset: type_asset,
        }
    })

    const handleCreateClassification = async (data) => {
        try {
            await createClassification({...data, type_asset, number})
            
            // Mostrar mensaje de éxito
            setAlertSnackbar({
                open: true,
                message: 'Clasificación creada exitosamente',
                severity: 'success'
            })
            
            // Restaurar el componente anterior
            restorePreviousComponent()
        } catch (error) {
            setAlertSnackbar({
                open: true,
                message: error.message || 'Error al crear la clasificación',
                severity: 'error'
            })
        }
    }

    return (
        <Box sx={{
            padding: '10px',
        }}>
            <form onSubmit={handleSubmit(handleCreateClassification)}>
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12, }}>
                    <Controller
                        control={control}
                        name="value"
                        rules={{ required: 'Este campo es requerido' }}
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Nombre" {...field} error={!!errors.value} helperText={errors.value?.message} />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12}}>
                        <Button type="submit" variant="contained" color="primary">Crear</Button>
                        <Button 
                            variant="contained" 
                            color="disabled" 
                            sx={{ ml: 1 }}
                            onClick={restorePreviousComponent}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}